import ModelUtil from '@leverege/model-util';
import { DetailModel, Formatters } from '@leverege/ui-attributes';
const VALUE_TYPE = 'geoPoint';
const TYPE = 'recovr.detail.position';
function getName() {
  return 'Position and Maps Link';
}
const base = {
  ...DetailModel,
  getName,
  ...ModelUtil.createAllValue('formatter')
};
delete base.create;
function create(attrName, objectType) {
  return DetailModel.create(TYPE, {
    attrName,
    objectType,
    formatter: Formatters.createFormatterModel(VALUE_TYPE)
  });
}
export default {
  TYPE,
  create,
  ...base
};